import Component from 'component';
import { BREAKPOINT } from '../constants';

let timeout = false;

const keys = {
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  space: 32
};

const direction = {
  37: -1,
  38: -1,
  39: 1,
  40: 1
};

class TabModule extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $tabs: this.$el.find('[role="tab"]'),
      $tablist: this.$el.find('[role="tablist"]')
    };

    this.setDirection();
    this.openHashedTab();
  }

  addListeners() {
    this.dom.$tabs.each((index, tab) => {
      $(tab).unbind('click');
      $(tab).on('click', ::this.handleClick);
      $(tab).on('keydown', ::this.handleKeydown);
      $(tab).on('keyup', ::this.handleKeyup);
    });

    $(window).on('resize', ::this.handleResize);
  }

  handleResize() {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      this.setDirection();
      this.verifyOpenTab();
    }, 200);
  }

  handleClick(event) {
    let target = event.target;

    if ($(event.target).attr('role') !== 'tab') {
      target = event.target.parentElement;
    }

    if (event.target.tagName !== 'A') {
      this.activateTab(target, false);
    }
  }

  handleKeydown(event) {
    switch (event.keyCode) {
    case keys.left:
    case keys.right:
      this.determineOrientation(event.keyCode, event.target);
      break;
    case keys.space:
      this.activateTab(event.target);
      break;
    default:
      break;
    }
  }

  handleKeyup(event) {
    event.preventDefault();

    switch (event.keyCode) {
    case keys.end:
      this.focusLastTab();
      break;
    case keys.home:
      this.focusFirstTab();
      break;
    case keys.up:
    case keys.down:
      this.determineOrientation(event.keyCode, event.target);
      break;
    default:
      break;
    }
  }

  focusFirstTab() {
    this.dom.$tabs.first().focus();
  }

  focusLastTab() {
    this.dom.$tabs.last().focus();
  }

  switchTabOnArrowPress(keyCode, target) {
    const index = $.inArray(target, this.dom.$tabs);

    if (direction[keyCode]) {
      if (index !== -1) {
        if (this.dom.$tabs[index + direction[keyCode]]) {
          this.dom.$tabs[index + direction[keyCode]].focus();
        } else if (keyCode === keys.left || keyCode === keys.up) {
          this.focusLastTab();
        } else if (keyCode === keys.right || keyCode === keys.down) {
          this.focusFirstTab();
        }
      }
    }
  }

  determineOrientation(keyCode, target) {
    const vertical = this.dom.$tablist.attr('aria-orientation') === 'vertical';
    let proceed = false;

    if (vertical) {
      if (keyCode === keys.up || keyCode === keys.down) {
        proceed = true;
      }
    } else {
      if (keyCode === keys.left || keyCode === keys.right) {
        proceed = true;
      }
    }

    if (proceed) {
      this.switchTabOnArrowPress(keyCode, target);
    }
  }

  activateTab(tab, setFocus = true) {
    const vertical = this.dom.$tablist.attr('aria-orientation') === 'vertical';
    const isTabOpen = $(tab).attr('aria-selected') === 'true';

    this.deactivateTabs();

    if (!isTabOpen || !vertical) {
      $(tab).removeAttr('tabindex');
      $(tab).attr('aria-selected', 'true');

      if ($(tab).attr('id')) {
        window.history.replaceState({}, document.title, `#${$(tab).attr('id')}`);
      }
    }

    if (setFocus) {
      $(tab).focus();
    }

    $(window).trigger('tabChange');
    setTimeout(() => {
      $(window).trigger('resize');
    }, 0);
  }

  deactivateTabs() {
    this.dom.$tabs.each((index, tab) => {
      $(tab).attr('tabindex', '-1');
      $(tab).attr('aria-selected', 'false');
    });
  }

  setDirection() {
    if (window.matchMedia(`(max-width: ${BREAKPOINT.tablet}px)`).matches) {
      this.dom.$tablist.attr('aria-orientation', 'vertical');
    } else {
      this.dom.$tablist.attr('aria-orientation', 'horizontal');
    }
  }

  verifyOpenTab() {
    const isSomeTabOpen = this.$el.find('[aria-selected="true"]');

    if (!isSomeTabOpen.length) {
      if (window.matchMedia(`(min-width: ${BREAKPOINT.tablet}px)`).matches) {
        this.dom.$tabs.first().attr('aria-selected', 'true');
      }
    }
  }

  openHashedTab() {
    const hash = window.location.hash;

    if (hash) {
      this.$el.find(hash).click();
      this.$el.find(hash).focus();
    }

    return;
  }
}

export default TabModule;



// WEBPACK FOOTER //
// ./src/tc/js/components/TabModule.js